import { useState, useRef, useEffect } from "react";
import { Accordion, Button, Card, Col, Modal, Row } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { getInvoiceSerialHistory, getActiveUnusedGuaranteeCards } from "../store/api/GetAllProduct";
import BihamtaTable from "../../Components/BihamtaTable";
import { invoiceTypes, invoiceTypesArray } from "../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory, faListAlt, faListOl, faTimes, faTruckPickup } from "@fortawesome/free-solid-svg-icons";
import { searchStorage4Modal } from "../../BaseInfo/store/api/StorageApi";
import BihamtaMultiSelect from "../../Components/BihamtaMultiSelect";

const ModalInvoiceSerials = (props) => {
    const searchData = useRef({});
    const searchCardData = useRef({});
    const { popData, setPopData, productGrouppingType } = props;
    const { show, setData, filterFaulty } = popData;
    const [list, getDataList] = useState();
    const [cardList, setCardList] = useState({});
    const [storageList, setStorageList] = useState([]);
    const currentStg = useRef();
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف" },
        { colName: "ProductHolder", colTitle: "مارک کالا", showInMobile: true, showCondition: () => Number(productGrouppingType) !== 1 },
        { colName: "ProductName", colTitle: (Number(productGrouppingType) !== 1 ? "نوع کالا" : "نام کالا"), showInMobile: true },
        { colName: "ProductModel", colTitle: "مدل کالا", showInMobile: true },
        { colName: "ProductSerial", colTitle: "سریال کالا", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colName: "UnitPrice", colTitle: "قیمت واحد", colType: "currency" },
        { colName: "InvoiceTypeName", colTitle: "نوع فاکتور" },
        { colName: "InvoiceNumber", colTitle: "شماره فاکتور" }
    ]
    const gcTableCols = [
        { colName: "RowNumber", colTitle: "ردیف" },
        { colName: "HolderName", colTitle: "مارک کالا", showInMobile: true },
        { colName: "GuaranteeCardNo", colTitle: "شماره گارانتی", showInMobile: true },
        { colName: "RelatedProductName+RelatedProductModel", colTitle: "مشخصات کالا", showInMobile: true, colType: "string" },
        { colName: "SerialNumber", colTitle: "سریال کالا", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } }
    ]
    function close() {
        if (setData)
            setData(null);
        setPopData({
            show: false
        })
        searchData.current = {};
    }
    function search(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        getInvoiceSerialHistory(searchData.current.SerialNumber ?? "", filterFaulty, searchData.current.InvoiceNumber ?? "", searchData.current.InvoiceType, getDataList);
    }
    function searchCards(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        getActiveUnusedGuaranteeCards(searchCardData.current.CardNo, searchCardData.current.SerialNumber, true, setCardList)
    }
    function select(item) {
        const { e, target, ...selected } = item;
        if (setData) {
            if (selected.InvoiceTypeStr === invoiceTypes.Disassembly) {
                selected.DisassemblyDetailID = selected.DetailID;
            }
            setData(selected);
        }
        setPopData({
            show: false
        })
    }
    function onStorageSelect(stg) {
        currentStg.current = { StorageID: Number(stg.value), StorageName: stg.text }

    }
    function selectCard(item) {
        if (!currentStg.current?.StorageID) {
            return;
        }
        const {e,target,...selected} = item;
        selected.ProductID = selected.RelatedProductID;
        selected.ProductModel = selected.RelatedProductModel ?? "";
        selected.ProductName = selected.RelatedProductName ?? "";
        selected.ProductHolder = selected.HolderName ?? "";
        selected.ProductSerial = selected.SerialNumber ?? "";
        selected.ProductCode = selected.RelatedProductCode ?? "";
        selected.GuaranteeID = selected.ID;
        selected.StorageID = currentStg.current.StorageID;
        selected.StorageName = currentStg.current.StorageName;
        selected.UnitPrice = 0;
        setData(selected);
        setPopData({ show: false });
    }
    useEffect(() => {
        if (show) {
            searchStorage4Modal("", 0, setStorageList, false);
        }
    }, [show])
    return (
        <Modal show={show} size="lg" onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faHistory} size="lg" />&nbsp;
                    تاریخچه سریال فاکتورها
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <Accordion defaultActiveKey="1">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="1" style={{ backgroundColor: "#4198d4", color: "white" }}>
                            <FontAwesomeIcon icon={faHistory} size="lg" />&nbsp;
                            تاریخچه سریال
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body style={{ border: "1px solid #4198d4" }}>
                                <Row style={{ margin: 0 }}>
                                    <Col md={4} style={{ margin: 0, padding: 2 }}>
                                        <input className="search-input" placeholder="سریال کالا" onChange={e => searchData.current.SerialNumber = e.target.value} onKeyDown={search} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                    </Col>
                                    <Col md={3} style={{ margin: 0, padding: 2 }}>
                                        <select className="search-input" name="InvoiceType" onChange={e => searchData.current.InvoiceType = e.target.value}>
                                            <option value="">نوع فاکتور</option>
                                            {invoiceTypesArray.map((type, i) => <option key={i} value={type.TypeName}>{type.TypeStr}</option>)}
                                        </select>
                                    </Col>
                                    <Col md={3} style={{ margin: 0, padding: 2 }}>
                                        <input className="search-input" onChange={e => searchData.current.InvoiceNumber = e.target.value} placeholder="شماره فاکتور" />
                                    </Col>
                                    <Col md={2} style={{ display: "flex", alignItems: "center", margin: 0, padding: 2 }}>
                                        <div>
                                            <Button className="group-Btn-smalll" onClick={search}><Search size={15} />&nbsp;جستـجو</Button>
                                        </div>
                                    </Col>
                                </Row>
                                <BihamtaTable columns={tableCols} dataList={list} maxHeight={500} rowClick={select} />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card className="mt-1">
                        <Accordion.Toggle as={Card.Header} eventKey="2" style={{ backgroundColor: "#416dd4", color: "white" }}>
                            <FontAwesomeIcon icon={faListAlt} size="lg" />&nbsp;
                            کارتهای گارانتی
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="2">
                            <Card.Body style={{ border: "1px solid #416dd4" }}>
                                <Row style={{ margin: 0 }}>
                                    <Col md={4} style={{ margin: 0, padding: 2 }}>
                                        <input className="search-input" placeholder="سریال کالا" onChange={e => searchCardData.current.SerialNumber = e.target.value} onKeyDown={searchCards} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                        <Button className="btn-input-tiny" onClick={searchCards} style={{ top: 6, left: 4 }}><Search size={20} /></Button>
                                    </Col>
                                    <Col md={4} style={{ margin: 0, padding: 2 }}>
                                        <input className="search-input" placeholder="شماره کارت" onChange={e => searchCardData.current.CardNo = e.target.value} onKeyDown={searchCards} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                        <Button className="btn-input-tiny" onClick={searchCards} style={{ top: 6, left: 4 }}><Search size={20} /></Button>
                                    </Col>
                                    <Col md={4} style={{ margin: 0, padding: 2 }}>
                                        <BihamtaMultiSelect dataSource={storageList?.Data} valueItem="StorageID" displayItem="StorageName"
                                            onItemCheckChanged={onStorageSelect} placeholder="انبار" selectOne inputClassName="search-input" labelStyle={{}} />
                                    </Col>
                                </Row>
                                <BihamtaTable columns={gcTableCols} maxHeight={500} dataList={cardList} rowClick={selectCard} />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>

                </Accordion>
            </Modal.Body>
        </Modal>
    )
}
export default ModalInvoiceSerials;
